import { Trans, useTranslation } from "react-i18next";
import {
  ListItem,
  SectionContainer,
  SectionSubTitle2,
  SectionTitle,
  SubSectionContainer,
} from "../PrivacyPolicyContent.styled";

export const UsePersonalDataSectionContent = (
  props: UsePersonalDataSectionContentProps
) => {
  const { i18n } = useTranslation();

  return (
    <SectionContainer>
      <SectionTitle>
        <Trans i18nKey={"privacyPolicy.usePersonalData.title"} />
      </SectionTitle>
      <SubSectionContainer>
        <SectionSubTitle2>
          <Trans i18nKey={"privacyPolicy.usePersonalData.text"} />
        </SectionSubTitle2>
        <div>
          {(
            i18n.t("privacyPolicy.usePersonalData.list", {
              returnObjects: true,
            }) as string[]
          ).map((definition, index) => (
            <ListItem
              key={index}
              dangerouslySetInnerHTML={{ __html: definition }}
            />
          ))}
        </div>
      </SubSectionContainer>
      <SubSectionContainer>
        <SectionSubTitle2>
          <Trans i18nKey={"privacyPolicy.usePersonalData.share"} />
        </SectionSubTitle2>
        <div>
          {(
            i18n.t("privacyPolicy.usePersonalData.shareList", {
              returnObjects: true,
            }) as string[]
          ).map((definition, index) => (
            <ListItem
              key={index}
              dangerouslySetInnerHTML={{ __html: definition }}
            />
          ))}
        </div>
      </SubSectionContainer>
    </SectionContainer>
  );
};

export interface UsePersonalDataSectionContentProps {}
